import { useContext } from 'react';

import { ConfigurationContext, IConfigurationContextValue } from './app-config.context';

export const useConfigurationContext = (): IConfigurationContextValue => {
  const context = useContext(ConfigurationContext);
  if (!context) {
    throw new Error('useConfigurationContext can not be used before ConfigurationContext is initialized');
  }
  return context;
};
